export default function validate(values, props) {
    const { messages, locale, config } = props
    const errors = {}

    if (!values.termsAndConditions) {
        errors.termsAndConditions = true
    }

    if (!values.refundPaymentMethod) {
        errors.refundPaymentMethod = messages.errors.refundPaymentMethod()
    }

    // Validation for COD Bank Transfer refund option
    if (values.refundPaymentMethod === 'ORIGINAL') {
        if (!values.bankCode) {
            errors.bankCode = messages.errors.required({})
        }
        if (!values.bankName) {
            errors.bankName = messages.errors.required({})
        }
        if (!values.sortCode) {
            errors.sortCode = messages.errors.required({})
        }
        if (!values.branchName) {
            errors.branchName = messages.errors.required({})
        }

        if (!values.accountName) {
            errors.accountName = messages.errors.required({})
        }

        // Validation for account name, non latin chars
        if (
            config?.global?.application?.brandId === 'theoutnet' &&
            config?.head?.flags?.nonLatinReturnsCountries?.includes(locale?.country) &&
            values.accountName
        ) {
            !values?.accountName?.match(/^[a-z\s]+$/iu)
                ? (errors.accountName = messages?.errors?.invalidCharacters({ nonLatin: values?.accountName }))
                : undefined
        }

        const swiftCodeLength = values.swiftCode?.length
        // basic swift code validation
        if (swiftCodeLength < 8 || swiftCodeLength > 11) {
            errors.swiftCode = messages.errors.swiftCode()
        }
        // show generic field required error when undefined or empty string
        if (!values.swiftCode && !(swiftCodeLength > 0)) {
            errors.swiftCode = messages.errors.required({})
        }

        const accNameLength = values.accountNo?.length
        // basic IBAN code validation
        if (accNameLength < 5 || accNameLength > 34) {
            errors.accountNo = messages.errors.ibanCode()
        }
        // show generic field required error when undefined or empty string
        if (!values.accountNo && !(accNameLength > 0)) {
            errors.accountNo = messages.errors.required({})
        }
    }

    return errors
}
